// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `pdf-list-dialog .product-image {
  cursor: pointer;
  margin-right: 35px;
  margin-bottom: 20px;
  overflow: hidden;
  border-radius: 4px;
}
pdf-list-dialog .product-image img {
  height: 100%;
  width: auto;
  max-width: none;
}
pdf-list-dialog .selected {
  border: solid;
  opacity: 0.3;
}
pdf-list-dialog .loading-shade {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
pdf-list-dialog .thumbnail {
  width: 100%;
  position: relative;
  background-color: #fff;
  border: 0 none;
  border-radius: 0px;
  padding: 0px;
  box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
pdf-list-dialog .thumbnail a {
  text-decoration: none;
}
pdf-list-dialog .modal-body {
  background-color: #f1f1f1;
}
pdf-list-dialog .effect .overlay {
  width: 100%;
  height: 164px;
  position: absolute;
  overflow: hidden;
  top: 0;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.5);
  transition: all 0.4s ease-in-out;
}
pdf-list-dialog .effect img {
  display: block;
  position: relative;
  transition: all 0.4s linear;
}
pdf-list-dialog .effect h4 {
  text-transform: uppercase;
  color: #fff;
  text-align: center;
  position: relative;
  font-size: 14px;
  background: rgba(0, 0, 0, 0.6);
  transform: translatey(-4px);
  transition: all 0.2s ease-in-out;
  padding: 12px;
}
pdf-list-dialog .effect a.info {
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  color: #fff;
  border: 1px solid #fff;
  background-color: transparent;
  opacity: 0;
  filter: alpha(opacity=0);
  transition: all 0.2s ease-in-out;
  margin: 44px 0 0 32px;
  padding: 7px 14px;
}
pdf-list-dialog .effect a.info:hover {
  box-shadow: 0 0 5px #fff;
}
pdf-list-dialog .thumbnail:hover img {
  transform: scale(0.9);
}
pdf-list-dialog .effect:hover .overlay {
  opacity: 1;
  filter: alpha(opacity=100);
}
pdf-list-dialog .effect:hover h2,
pdf-list-dialog .thumbnail:hover a.info {
  opacity: 1;
  filter: alpha(opacity=100);
  transform: translatey(0);
}
pdf-list-dialog .effect:hover a.info {
  transition-delay: 0.2s;
}
pdf-list-dialog .template_img {
  height: 100px !important;
  width: 150px !important;
}
pdf-list-dialog .no_img {
  height: 100px !important;
  width: 150px !important;
}

@media screen and (max-width: 599px) {
  .pdf-list-dialog {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .pdf-list-dialog {
    width: 70%;
  }
}
.pdf-list-dialog .mat-mdc-dialog-container {
  padding: 0;
}
.pdf-list-dialog .dialog-content-wrapper {
  max-height: 85vh;
  display: flex;
  flex-direction: column;
}
@media screen and (max-width: 599px) {
  .pdf-list-dialog .dialog-content-wrapper .top-bg {
    min-height: 110px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/directives/pdf-templates/pdf-list-dialog/pdf-list-dialog.component.scss","webpack://./src/@fuse/scss/partials/_breakpoints.scss"],"names":[],"mappings":"AAGI;EAQI,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AATR;AAWQ;EACI,YAAA;EACA,WAAA;EACA,eAAA;AATZ;AAaI;EACI,aAAA;EACA,YAAA;AAXR;AAcI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAZR;AAeI;EACI,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EAGA,6EAAA;AAbR;AAgBI;EACI,qBAAA;AAdR;AAiBI;EACI,yBAAA;AAfR;AAkBI;EAEI,WAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;EACA,oCAAA;EAEA,gCAAA;AAjBR;AAoBI;EACI,cAAA;EACA,kBAAA;EAEA,2BAAA;AAlBR;AAqBI;EACI,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,8BAAA;EAGA,2BAAA;EAEA,gCAAA;EACA,aAAA;AAnBR;AAsBI;EACI,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;EACA,6BAAA;EACA,UAAA;EACA,wBAAA;EAEA,gCAAA;EACA,qBAAA;EACA,iBAAA;AApBR;AAuBI;EACI,wBAAA;AArBR;AAwBI;EAGI,qBAAA;AAtBR;AAyBI;EACI,UAAA;EACA,0BAAA;AAvBR;AA0BI;;EAEI,UAAA;EACA,0BAAA;EAGA,wBAAA;AAxBR;AA2BI;EAEI,sBAAA;AAzBR;AA4BI;EACI,wBAAA;EACA,uBAAA;AA1BR;AA6BI;EACI,wBAAA;EACA,uBAAA;AA3BR;;ACxFQ;EDuHR;IAEQ,WAAA;EA5BN;AACF;AC9FQ;EDuHR;IAMQ,UAAA;EA3BN;AACF;AA6BI;EACI,UAAA;AA3BR;AA8BI;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;AA5BR;AC3GQ;EDyIA;IAEQ,4BAAA;EA5Bd;AACF","sourcesContent":["@import \"src/@fuse/scss/partials/breakpoints\";\n\npdf-list-dialog {\n    .product-image {\n        // cursor: pointer;\n        // overflow: hidden;\n        // width: 128px;\n        // height: 128px;\n        // margin-right: 16px;\n        // margin-bottom: 16px;\n        // border-radius: 4px;\n        cursor: pointer;\n        margin-right: 35px;\n        margin-bottom: 20px;\n        overflow: hidden;\n        border-radius: 4px;\n\n        img {\n            height: 100%;\n            width: auto;\n            max-width: none;\n        }\n    }\n\n    .selected {\n        border: solid;\n        opacity: 0.3;\n    }\n\n    .loading-shade {\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        background: rgba(0, 0, 0, 0.15);\n        z-index: 1000;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .thumbnail {\n        width: 100%;\n        position: relative;\n        background-color: #fff;\n        border: 0 none;\n        border-radius: 0px;\n        padding: 0px;\n        -webkit-box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n        -moz-box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n        box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n    }\n\n    .thumbnail a {\n        text-decoration: none;\n    }\n\n    .modal-body {\n        background-color: #f1f1f1;\n    }\n\n    .effect .overlay {\n        // width: 195px;\n        width: 100%;\n        height: 164px;\n        position: absolute;\n        overflow: hidden;\n        top: 0;\n        opacity: 0;\n        background-color: rgba(0, 0, 0, 0.5);\n        -webkit-transition: all .4s ease-in-out;\n        transition: all .4s ease-in-out\n    }\n\n    .effect img {\n        display: block;\n        position: relative;\n        -webkit-transition: all .4s linear;\n        transition: all .4s linear;\n    }\n\n    .effect h4 {\n        text-transform: uppercase;\n        color: #fff;\n        text-align: center;\n        position: relative;\n        font-size: 14px;\n        background: rgba(0, 0, 0, 0.6);\n        -webkit-transform: translatey(-4px);\n        -ms-transform: translatey(-4px);\n        transform: translatey(-4px);\n        -webkit-transition: all .2s ease-in-out;\n        transition: all .2s ease-in-out;\n        padding: 12px;\n    }\n\n    .effect a.info {\n        text-decoration: none;\n        display: inline-block;\n        text-transform: uppercase;\n        color: #fff;\n        border: 1px solid #fff;\n        background-color: transparent;\n        opacity: 0;\n        filter: alpha(opacity=0);\n        -webkit-transition: all .2s ease-in-out;\n        transition: all .2s ease-in-out;\n        margin: 44px 0 0 32px;\n        padding: 7px 14px;\n    }\n\n    .effect a.info:hover {\n        box-shadow: 0 0 5px #fff;\n    }\n\n    .thumbnail:hover img {\n        -ms-transform: scale(0.9);\n        -webkit-transform: scale(0.9);\n        transform: scale(0.9);\n    }\n\n    .effect:hover .overlay {\n        opacity: 1;\n        filter: alpha(opacity=100);\n    }\n\n    .effect:hover h2,\n    .thumbnail:hover a.info {\n        opacity: 1;\n        filter: alpha(opacity=100);\n        -ms-transform: translatey(0);\n        -webkit-transform: translatey(0);\n        transform: translatey(0);\n    }\n\n    .effect:hover a.info {\n        -webkit-transition-delay: .2s;\n        transition-delay: .2s;\n    }\n\n    .template_img {\n        height: 100px !important;\n        width: 150px !important;\n    }\n\n    .no_img {\n        height: 100px !important;\n        width: 150px !important;\n    }\n}\n\n.pdf-list-dialog {\n    @include media-breakpoint('xs') {\n        width: 100%;\n    }\n\n    @include media-breakpoint('gt-xs') {\n        width: 70%;\n    }\n\n    .mat-mdc-dialog-container {\n        padding: 0;\n    }\n\n    .dialog-content-wrapper {\n        max-height: 85vh;\n        display: flex;\n        flex-direction: column;\n\n        .top-bg {\n            @include media-breakpoint(\"xs\") {\n                min-height: 110px !important;\n            }\n        }\n    }\n}","// Media step breakpoint mixin based on Angular Material lib\n$breakpoints: (\n    xs: 'screen and (max-width: 599px)',\n    sm: 'screen and (min-width: 600px) and (max-width: 959px)',\n    md: 'screen and (min-width: 960px) and (max-width: 1279px)',\n    lg: 'screen and (min-width: 1280px) and (max-width: 1919px)',\n    xl: 'screen and (min-width: 1920px) and (max-width: 5000px)',\n    lt-sm: 'screen and (max-width: 599px)',\n    lt-md: 'screen and (max-width: 959px)',\n    lt-lg: 'screen and (max-width: 1279px)',\n    lt-xl: 'screen and (max-width: 1919px)',\n    gt-xs: 'screen and (min-width: 600px)',\n    gt-sm: 'screen and (min-width: 960px)',\n    gt-md: 'screen and (min-width: 1280px)',\n    gt-lg: 'screen and (min-width: 1920px)'\n) !default;\n\n// Re-map the breakpoints for the helper classes\n$helper-breakpoints: (\n    xs: null,\n    sm: 'gt-xs',\n    md: 'gt-sm',\n    lg: 'gt-md',\n    xl: 'gt-lg'\n);\n\n@mixin media-breakpoint($breakpointName) {\n\n    $mediaQuery: map-get($breakpoints, $breakpointName);\n\n    @if ($mediaQuery == null) {\n        @content\n    } @else {\n        @media #{$mediaQuery} {\n            @content\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
